import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import md5 from 'js-md5';
import utils from './utils';
import TouTiaoApp from './TouTiaoApp';

import urls from 'network/urls';

import CPlanLogin from './CPlanLogin';
import CPlanUserCenter from './CPlanUserCenter';
import cplanStore from './cplan/store';
import cplanRouter from './cplan/router';
import cplanUrls from './cplan/network/urls'


import RebateLogin from './RebateLogin';
import RebateStore from './rebateLogin/store';
import RebateRouter from './rebateLogin/router';
import RebateUrls from './rebateLogin/network/urls'


import NormalLogin from './views/Normal/NormalLogin';
import NormalUserCenter from './views/Normal/NormalUserCenter';
import NormalStore from './normal/store';
import NormalRouter from './normal/router';
import NormalUrls from './normal/network/urls'

import GaoBaoBanLogin from './views/GaoBaoBan/GaoBaoBanLogin.vue';
import GaoBaoBanUserCenter from './views/GaoBaoBan/GaoBaoBanUserCenter.vue';
import GaoBaoBanStore from './gaoBaoBan/store';
import GaoBaoBanRouter from './gaoBaoBan/router';
import GaoBaoBanUrls from './gaoBaoBan/network/urls'


import PayCenter from './views/payCenter/PayCenter.vue';


import SdkV3App from './views/SdkV3/SdkV3App.vue';
import V3Urls from './SdkV3/network/urls';
import V3Store from './SdkV3/store';



// 七鱼初始化
(function (w, d, n, a, j) {
  w[n] = w[n] || function () {
      (w[n].a = w[n].a || []).push(arguments);
  };
  j = d.createElement('script');
  j.async = true;
  j.src = 'https://qiyukf.com/script/b973a18055397010de464fdf1a1bc55b.js?hidden=1';
  d.body.appendChild(j);
})(window, document, 'ysf');

// import urls from './network/urls'

Vue.prototype.$md5 = md5
// Vue.prototype.urls = urls

// 在vue中调用 this.sendToClient('方法名?'.concat(JSON.stringify(params)))
// 在安卓端可以通过拦截url获取到
Vue.prototype.sendToClient = function(text){
  var iFrame;
  iFrame = document.createElement('iframe');
  iFrame.setAttribute('src', 'okgameclient:'.concat(text));
  iFrame.setAttribute('style', 'display:none;');
  iFrame.setAttribute('height', '0px');
  iFrame.setAttribute('width', '0px');
  iFrame.setAttribute('frameborder', '0');
  document.body.appendChild(iFrame);
  iFrame.parentNode.removeChild(iFrame);
  iFrame = null;
}


// 在vue中调用 this.sendToClient('方法名?'.concat(JSON.stringify(params)))
// 在安卓端可以通过拦截url获取到
Vue.prototype.sendToCPlanClient = function(text){
  var iFrame;
  iFrame = document.createElement('iframe');
  iFrame.setAttribute('src', 'cplanclient:'.concat(text));
  iFrame.setAttribute('style', 'display:none;');
  iFrame.setAttribute('height', '0px');
  iFrame.setAttribute('width', '0px');
  iFrame.setAttribute('frameborder', '0');
  document.body.appendChild(iFrame);
  iFrame.parentNode.removeChild(iFrame);
  iFrame = null;
}

// 接收安卓端发送的信息
// window.getUnreadMessages = function(unreadMessages){
//   // let dataJson = JSON.parse(data);
//   store.commit("updateUnreadMessages", unreadMessages);
// }
// window.onActivityResume = function(){
//   // let dataJson = JSON.parse(data);
//   store.commit("onActivityResume");
// }

Vue.config.productionTip = false

let appObject = {
  el: '#app',
  router,
  store: store, 
  render: h => h(App)
}
let type = utils.getUrlKey("type")
if ("toutiao" === type) {
  appObject = {
    el: '#app',
    router,
    store: store, 
    render: h => h(TouTiaoApp)
  }
}
if ("swLogin" === type) {
  Vue.prototype.urls = cplanUrls
  appObject = {
    el: '#app',
    router: cplanRouter,
    store: cplanStore, 
    render: h => h(CPlanLogin)
  }
}
if ("swUserCenter" === type) {
  Vue.prototype.urls = cplanUrls
  appObject = {
    el: '#app',
    router: cplanRouter,
    store: cplanStore, 
    render: h => h(CPlanUserCenter)
  }
}
if ("rebateLogin" === type) {
  Vue.prototype.urls = RebateUrls
  appObject = {
    el: '#app',
    router: RebateRouter,
    store: RebateStore, 
    render: h => h(RebateLogin)
  }
}

if ("normalLogin" === type) {
  Vue.prototype.urls = NormalUrls
  appObject = {
    el: '#app',
    router: NormalRouter,
    store: NormalStore, 
    render: h => h(NormalLogin)
  }
}
if ("normalCenter" === type) {
  Vue.prototype.urls = NormalUrls
  appObject = {
    el: '#app',
    router: NormalRouter,
    store: NormalStore, 
    render: h => h(NormalUserCenter)
  }
}

if ("gaoBaoBanLogin" === type) {
  Vue.prototype.urls = GaoBaoBanUrls
  appObject = {
    el: '#app',
    router: GaoBaoBanRouter,
    store: GaoBaoBanStore, 
    render: h => h(GaoBaoBanLogin)
  }
}
if ("gaoBaoBanCenter" === type) {
  Vue.prototype.urls = GaoBaoBanUrls
  appObject = {
    el: '#app',
    router: GaoBaoBanRouter,
    store: GaoBaoBanStore, 
    render: h => h(GaoBaoBanUserCenter)
  }
}


if ("payCenter" === type) {
  Vue.prototype.urls = urls
  appObject = {
    el: '#app',
    router,
    store: store, 
    render: h => h(PayCenter)
  }
}


if ("sdkV3" === type) {
  Vue.prototype.urls = V3Urls
  appObject = {
    el: '#app',
    router,
    store: V3Store, 
    render: h => h(SdkV3App)
  }
}


/* eslint-disable no-new */
new Vue(appObject)


// WEBPACK FOOTER //
// ./src/main.js